import { createBaseAction } from '@essent/common';
// eslint-disable-next-line @nx/enforce-module-boundaries
import type { GenericModalSources } from '@legacy/common-ui-shared-interfaces';

export const logout = createBaseAction<{
  redirect_url: string;
  chatEnabled: boolean;
}>('[Navigation] Logout');

export const helpClickedAction = createBaseAction<{
  source: GenericModalSources;
  additionalPayload?: any;
  interpolatablePayload?: any;
}>('[Navigation] Minimal header help clicked');

export const logoClickedAction = createBaseAction<{
  source: GenericModalSources;
  additionalPayload?: any;
  interpolatablePayload?: any;
}>('[Navigation] Minimal header logo clicked');
